export const REGISTER_BASIC = "/auth/register/basic";
export const REGISTER_INCOME = "/auth/register/income";
export const REGISTER_AADHAR = "/auth/register/aadhaar";
export const REGISTER_AADHAR_OTP = "/auth/aadhar-verification";
export const VERIFY_AADHAR_OTP = "/auth/verify-otp";
export const SEND_OTP = "/auth/send-otp";
export const FINAL_SUBMIT = "/auth/register/submit";

